// function convertToISO(dateString) {

//   // Assuming dateString is in the format "dd-mm-yyyy"
//   const [day, month, year] = dateString.split("-").map(Number);

//   // Create a new date object (note: month is 0-indexed in JavaScript)
//   const dateObj = new Date(year, month - 1, day);

//   // Return the date as an ISO string

//   return dateObj.toISOString();
// }

// export { convertToISO };

function convertToISO(dateString) {
  // Assuming dateString is in the format "dd-mm-yyyy"
  if (dateString) {
    let day, month, year;

    if (dateString.includes("/")) {
      [day, month, year] = dateString.split("/").map(Number);
    } else if (dateString.includes("-")) {
      [year, month, day] = dateString.split("-").map(Number);
    } else {
      return null; // Invalid format
    }

    // Create a new date object with the provided date and set the time to 00:00:00.000
    const dateObj = new Date(year, month - 1, day, 0, 0, 0, 0);

    // Calculate timezone offset for IST (India Standard Time +05:30)
    const offset = 330; // Offset in minutes (+5 hours 30 minutes)
    const localDate = new Date(dateObj.getTime() + offset * 60000);

    // Formatting to ISO string with manual adjustment for local timezone
    const isoDateString = localDate.toISOString().replace("Z", "");
    return isoDateString;
  }
  return null;
}

export { convertToISO };
